import React, { Component } from 'react';
import _ from 'underscore';
import Utils from 'utils/Utils.js';

import EditTime from './EditTime.js';


var options = {hour:[], minute:[]};

_.times(12,(i)=>{
    var h = i+1;
    options.hour.push({key:h, text:String(h), value:h});
});

_.times(60,(m)=>{
    options.minute.push({key:m, text:Utils.padZeros(String(m),2), value:m});
});

options.ampm = [
    {key:1, text:'AM', value:'AM'},
    {key:2, text:'PM', value:'PM'},
];



class EditTimeContainer extends Component {
    constructor(props) {
        super(props);
        var time   = Math.round(props.initialTime);
        var hour   = (Math.floor(time/60)+11)%12+1;
        var minute = (time%60);
        var ampm   = (time/ 60 >= 12 ? "PM" : "AM" );
        this.state = {hour, minute, ampm};
        this.updateTime = this.updateTime.bind(this);
        this.getTime = this.getTime.bind(this);
    }

    updateTime(event, {name, value}) {
        this.setState({[name]:value});
    }

    getTime() {
        var h = this.state.hour%12;
        return (this.state.ampm=='PM' ? (h+12) : h)*60 + this.state.minute;
    }

    render() {
        return <EditTime {...this.props}
                   options={options}
                   time={this.getTime()}
                   hour={this.state.hour}
                   minute={this.state.minute}
                   ampm={this.state.ampm}
                   updateTime={this.updateTime} />;
    }
}

export default EditTimeContainer;



// WEBPACK FOOTER //
// ./src/modules/categories/EditTimeContainer.js